<template>
    <div class="fillcontain">
      <br/>
        <el-divider content-position="left"><span style="font-size: 30px">基础信息</span></el-divider>
          <el-row>
            <el-col :span="4">
              <el-form ref="form" label-width="180px">
                <el-form-item label="头像:">
                  <img :src="consumer.photoUrl" v-if="consumer.photoUrl != null" width="50" height="50"/>
                </el-form-item>
                <el-form-item label="姓名:">
                  {{consumer.name}}
                </el-form-item>
                <el-form-item label="昵称:">
                  {{consumer.nickName}}
                </el-form-item>
                <el-form-item label="电话:">
                  {{consumer.telephone}}
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="4">
              <el-form ref="form" label-width="180px">
                <el-form-item label="性别:">
                    <span v-if="consumer.sex == 1">
                      男
                    </span>
                  <span v-else-if="consumer.sex == 2">
                      女
                    </span>
                  <span v-else>
                      保密
                    </span>
                </el-form-item>

                <el-form-item label="加入时间:">
                  {{consumer.createTime}}
                </el-form-item>
                <el-form-item label="状态:">
                   <span v-if="consumer.black">
                      封号中
                     <el-button
                       v-if="consumer.black"
                       size="mini"
                       style="margin: 5px"
                       @click="blacklist(consumer)">
                    移出黑名单
                  </el-button>

                    </span>
                  <span v-else>
                      正常
                    <el-button
                      v-if="!consumer.black"
                      size="mini"
                      style="margin: 5px"
                      @click="blacklist(consumer)">
                    加入黑名单
                  </el-button>
                    </span>

                </el-form-item>
                <el-form-item label="生日:">
                  {{consumer.birthday}}
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row>
            <el-col  :span="4">
              <el-button
                type="success"
                style="margin: 5px"
                @click="dialog2.dialogFormVisible = true">
                修改会员信息
              </el-button>
            </el-col>
          </el-row>
          <el-divider content-position="left"><span style="font-size: 30px">会员卡信息</span></el-divider>

          <el-row>
            <el-col  :span="6">
              <span v-if="plugin == null">未启用会员卡插件</span>
              <span v-if="plugin != null && consumer.userCard == null">用户未开通会员卡<el-button size="mini" style="margin: 5px"  type="success" @click="openVip(consumer)">为其开通会员卡</el-button></span>
              <el-form label-width="180px"  v-if="plugin != null && consumer.userCard != null">
                <!--<el-form-item label="手机号">
                  <span>{{ consumer.userCard.telephone }}</span>
                </el-form-item>-->
                <el-form-item label="钱包:" v-if="consumer.userCard.supplyBalance">
                  <span>￥{{ consumer.userCard.balance/100 }}</span>
                  <el-button size="mini" type="success" style="margin: 5px" @click="openUserCardAction(consumer.userCard,'balance')">更改</el-button>
                  <el-button size="mini" type="success" style="margin: 5px" @click="goUserCardLog(consumer.userCard,'balance')">查看记录</el-button>
                </el-form-item>
                <el-form-item label="积分:" v-if="consumer.userCard.supplyPoint">
                  <span>{{ consumer.userCard.point }}</span>
                  <el-button size="mini" type="success" style="margin: 5px" @click="openUserCardAction(consumer.userCard,'point')">更改</el-button>
                  <el-button size="mini" type="success" style="margin: 5px" @click="goUserCardLog(consumer.userCard,'point')">查看记录</el-button>
                </el-form-item>
                <el-form-item label="等级:" v-if="consumer.userCard.supplyGrade">
                  <span>{{ consumer.userCard.grade }}</span>
                  <el-button size="mini" type="success" style="margin: 5px" @click="openUserCardAction(consumer.userCard,'grade')">更改</el-button>
                  <el-button size="mini" type="success" style="margin: 5px" @click="goUserCardLog(consumer.userCard,'grade')">查看记录</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col  :span="6">
            </el-col>
          </el-row>

      <el-dialog :title="tmpUserCardAction.title" :visible.sync="tmpUserCardAction.dialog" >
        <el-form :model="tmpUserCardAction">
          <el-form-item :label="tmpUserCardAction.sTitle">
            <el-input-number v-model="tmpUserCardAction.value" :min="tmpUserCardAction.min" :max="tmpUserCardAction.max"></el-input-number>
            <p>正数为增加，负数为扣除</p>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="tmpUserCardAction.note" type="textarea" rows="4" ></el-input>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="tmpUserCardAction.dialog = false">取 消</el-button>
          <el-button type="primary" @click="tmpUserCardActionHandler">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改会员信息" :visible.sync="dialog2.dialogFormVisible" :close-on-click-modal="dialog2.close">
        <el-form :model="consumer">
          <el-form-item label="姓名" label-width="100px">
            <el-input v-model="consumer.name"></el-input>
          </el-form-item>
          <el-form-item label="昵称" label-width="100px">
            <el-input v-model="consumer.nickName"></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="100px">
            <el-radio v-model="consumer.sex" label="1">男</el-radio>
            <el-radio v-model="consumer.sex" label="2">女</el-radio>
            <el-radio v-model="consumer.sex" label="0">保密</el-radio>
          </el-form-item>
          <el-form-item label="电话" label-width="100px">
            <el-input v-model="consumer.telephone"></el-input>
          </el-form-item>
          <el-form-item label="生日" label-width="100px">
            <el-date-picker
              v-model="consumer.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog2.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveCustomer">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                consumer:{
                    id:0,
                    account:"",
                    name:"",
                    number:"",
                    sex:"1",
                    birthday:"",
                    telephones:"",
                    note:"",
                    isFreeze:"0",
                    role_id:0,
                },
              tmpUserCardAction:{
                id:0,
                title:"修改金额",
                sTitle:"金额",
                min:0,
                max:1000000,
                note:"",
                value:0,
                dialog:false,
                type:"balance"
              },

              dialog:{
                dialogFormVisible:false,
                title:"新增",
                close:false,
              },
              dialog2:{
                dialogFormVisible:false,
                close:false,
              },
              consumer_id:0,
              plugin:null,
            }
        },
        created(){
          this.consumer_id = this.$route.query.id;
          this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/consumers', {id:this.consumer_id}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {

                    that.plugin = res.data.plugin;
                    var consumers = res.data.consumers.content;
                    that.consumer = consumers[0];
                    that.consumer.sex = ""+that.consumer.sex;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
          openUserCardAction(row,type){
              console.log(row);
            this.tmpUserCardAction.id = row.id
            this.tmpUserCardAction.type = type;
            this.tmpUserCardAction.value = 0;
            this.tmpUserCardAction.note = "";
            if(type == 'balance'){
              this.tmpUserCardAction.title = "修改余额";
              this.tmpUserCardAction.sTitle= "余额";
              this.tmpUserCardAction.min = -row.balance;
            }else if(type == 'point'){
              this.tmpUserCardAction.title = "修改积分";
              this.tmpUserCardAction.sTitle= "积分";
              this.tmpUserCardAction.min = -row.point;
            }else if(type == 'grade'){
              this.tmpUserCardAction.title = "修改等级";
              this.tmpUserCardAction.sTitle= "等级";
              this.tmpUserCardAction.min = -row.grade+1;
            }

            this.tmpUserCardAction.dialog = true;
          },
          openVip(row){
            var that = this;
            this.$prompt('确定要开通会员卡吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPlaceholder:"请输入客户的手机号码"
            }).then(({ value }) => {
              if(value.trim() == ""){
                that.$message({
                  message: '开通失败,手机号码不能为空',
                  type: 'error'
                });
              }else{
                that.handleOpenVip(row,value);
              }

            }).catch(() => {

            });
          },
          handleOpenVip(row,value) {
            this.loading = true;
            var that = this;
            that.$api.post('/store/vip_card/add/'+row.id, {telephone:value}, response => {
              if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: '开通成功',
                    type: 'success'
                  });
                  this.initData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }

                this.loading = false;
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });

                this.loading = false;
              }

            });
          },
          tmpUserCardActionHandler(row){
            if(this.tmpUserCardAction.value <= this.tmpUserCardAction.min){
              this.$message({
                message: this.tmpUserCardAction.sTitle+"不能小于"+this.tmpUserCardAction.min,
                type: 'warning'
              });
              return;
            }
            this.loading = true;
            this.$api.put('/store/vip_card/'+this.tmpUserCardAction.id, this.tmpUserCardAction, response => {
              if (response.status >= 200 && response.status < 300) {

                this.tmpUserCardAction.dialog = false;
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: "修改成功",
                    type: 'success'
                  });
                  this.initData();
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }

                this.loading = false;
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });

                this.loading = false;

              }
            });

          },

          saveCustomer(){
            this.loading = true;
            this.$api.put('/store/consumers/'+this.consumer.id, this.consumer, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: "修改成功",
                    type: 'success'
                  });
                  this.initData();
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
                this.dialog2.dialogFormVisible = false;
                this.loading = false;
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });

                this.loading = false;

              }
            });

          },

          handleEditRealPrice(row){
            var that = this;
            this.$prompt('请输入充值金额', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(({ value }) => {
              that.$api.post('/store/consumers/'+row.id, {chargePrice:value*100}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.initData();
                    this.$message({
                      message: "充值成功",
                      type: 'success'
                    });
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                  this.initData();
                }
                this.loading = false;
              });

            }).catch(() => {

            });
          },
          goUserCardLog(row,type){//查看日志
            this.$router.push({path:'/store/userCardLogs',query: {user_card_id: row.id,type:type}});
          },
          blacklist(row) {
            var that = this;
            that.$api.get('/store/blacklist', {user_id:row.user.id}, response => {
              if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  if(res.data.blacklists.content.length > 0){
                    this.$confirm('要将该用户移出黑名单吗?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {

                      this.loading = true;
                      that.$api.delete('/store/blacklist', {user_id: row.user.id}, response => {
                        if (response.status >= 200 && response.status < 300) {
                          console.log(response.data);
                          var res = response.data;
                          if (res.code == 0) {
                            this.$message({
                              message: "移出成功,该用户可正常在本店下单",
                              type: 'success'
                            });
                            this.initData();
                          } else {
                            this.$message({
                              message: res.msg,
                              type: 'error'
                            });
                          }

                          this.loading = false;
                        } else {
                          this.$message({
                            message: "服务器维护中",
                            type: 'error'
                          });

                          this.loading = false;
                        }
                      });

                    }).catch(() => {

                    });
                  } else {
                    this.$confirm('要将该用户加入黑名单吗?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {

                      this.loading = true;
                      that.$api.post('/store/blacklist', {user_id: row.user.id}, response => {
                        if (response.status >= 200 && response.status < 300) {
                          console.log(response.data);
                          var res = response.data;
                          if (res.code == 0) {
                            this.$message({
                              message: "加入成功,该用户将无法在本店下单",
                              type: 'success'
                            });
                            this.initData();
                          } else {
                            this.$message({
                              message: res.msg,
                              type: 'error'
                            });
                          }

                          this.loading = false;
                        } else {
                          this.$message({
                            message: "服务器维护中",
                            type: 'error'
                          });

                          this.loading = false;
                        }
                      });

                    }).catch(() => {

                    });

                    this.loading = false;
                  }
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });

                this.loading = false;
              }
            });
          },

        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/ConsumerDetail.vue